var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28572 0C2.816 0 0 2.816 0 6.28572C0 9.75543 2.816 12.5714 6.28572 12.5714C9.75543 12.5714 12.5714 9.75543 12.5714 6.28572C12.5714 2.816 9.75543 0 6.28572 0ZM1.25714 6.28572C1.25714 3.50743 3.50743 1.25714 6.28572 1.25714C7.44857 1.25714 8.51714 1.65314 9.36572 2.31943L2.31943 9.36572C1.65314 8.51714 1.25714 7.44857 1.25714 6.28572ZM6.28572 11.3143C5.12286 11.3143 4.05429 10.9183 3.20571 10.252L10.252 3.20571C10.9183 4.05429 11.3143 5.12286 11.3143 6.28572C11.3143 9.064 9.064 11.3143 6.28572 11.3143Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/BlockIcon.d3e1253254a2aeb8c3327dffd10d6f5b.svg";
export { ForwardRef as ReactComponent };